import req from './http.js'

// 取得顧客評價資料
export const apiGetUserFeedbackList = params => req('post', '/reservation/customerServices/getUserFeedbackList', params)

// 取得訂單資料
export const apiSearchTicketList = params => req('post', '/reservation/customerServices/csSearchTicketList', params)

// 補核銷功能
export const apiGetTicketInfoForCsPostConfirm = params => req('post', '/reservation/customerServices/getTicketInfoForCsPostConfirm', params)

// 確定核銷
export const apiConfirmUseTicket = params => req('post', '/reservation/customerServices/csConfirmUseTicket', params)

// 分票
export const apiDispatchTicket = params => req('post', '/reservation/customerServices/dispatchTicket', params)

// 歸還此票券給原購者
export const apiReturnDispatchedTicket = params => req('post', '/reservation/customerServices/csReturnDispatchedTicket', params)

// 會員繼承
export const apiShoplineMemberMerge = params => req('post', '/reservation/customerServices/shoplineMemberMerge', params)

// 延長QR Code時效
export const apiRescueTicketQRCode = params => req('post', '/reservation/customerServices/rescueTicketQRCode', params)
